import React, { FC } from "react";
import { useResourceSelectorContext } from "../../../components/ResourceSelector/ResourceSelector";

import { CatalogContainer, Portal } from "../styled";
import { Cards } from "./Cards/Cards";
import { TopBar } from "./TopBar/TopBar";

import { CatalogHeader } from "./CatalogHeader/CatalogHeader";

export const Catalog: FC = () => {
  const { zIndex } = useResourceSelectorContext();

  return (
    <Portal shadowedBackground={false}>
      <CatalogContainer zIndex={zIndex} asDialog={false}>
        <CatalogHeader>
          <TopBar />
        </CatalogHeader>
        <Cards />
      </CatalogContainer>
    </Portal>
  );
};
